import Close from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useCallback, useState } from "react";
import { CeTextField } from "../generic/components/form-fields/ce-text-field";

import type { FC } from "react";

export const LongformDialog: FC<{
  open: boolean;
  contentType: string;
  prompt: string;
  onSkip: () => void;
  onContinue: (prompt: string) => void;
  onClose: () => void;
}> = ({ open, contentType, prompt, onSkip, onContinue, onClose }) => {
  const [value, setValue] = useState(prompt);

  const handleContinue = useCallback(() => {
    onContinue(value);
  }, [onContinue, value]);

  return (
    <Dialog open={open}>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          Add more detail for a better {contentType}
          <IconButton
            onClick={onClose}
            data-analytics-id="longform-prompt-dialog-close"
            title="Cancel"
          >
            <Close data-testid="CloseIcon" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack gap={3}>
          <Typography color="text.secondary">
            Enter as much context as you can to improve the quality of the {contentType} we
            generate. You could even consider pasting in content from a policy document or intranet
            article.
          </Typography>
          <CeTextField
            analyticsCategory="mfai"
            label={`Describe what your ${contentType} is about`}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            fullWidth
            multiline
            slotProps={{ htmlInput: { "data-testid": "longform-prompt-dialog-textfield" } }}
            minRows={20}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button data-analytics-id="create-content-longform-prompt-skip" onClick={onSkip}>
          Skip
        </Button>
        <Button
          data-analytics-id="create-content-longform-prompt-continue"
          onClick={handleContinue}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
